(() => {
  // Indian PIN code prefixes: state or region | Safexpress transit band
  // (0 Rajasthan, 1 North and West, 2 South, East and hill states, 3 remote regions). The longest prefix wins.
  const BANDS = `11|Delhi|1
12-13|Haryana|1
14-16|Punjab|1
160|Chandigarh and Punjab|1
17|Himachal Pradesh|2
18-19|Jammu and Kashmir|3
194|Ladakh|3
20-28|Uttar Pradesh|1
246-249|Uttarakhand|2
262-263|Uttarakhand|2
30-34|Rajasthan|0
36-39|Gujarat|1
40-44|Maharashtra|1
403|Goa|1
45-48|Madhya Pradesh|1
49|Chhattisgarh|2
50|Telangana|2
51-53|Andhra Pradesh|2
56-59|Karnataka|2
60-64|Tamil Nadu and Puducherry|2
67-69|Kerala|2
68255|Lakshadweep|3
70-74|West Bengal|2
737|Sikkim|3
744|Andaman and Nicobar Islands|3
75-77|Odisha|2
78|Assam|3
790-792|Arunachal Pradesh|3
793-794|Meghalaya|3
795|Manipur|3
796|Mizoram|3
797-798|Nagaland|3
799|Tripura|3
80-85|Bihar and Jharkhand|2`;
  const regions = new Map();
  for (const line of BANDS.split('\n')) {
    const [range, place, band] = line.split('|');
    const [from, to = from] = range.split('-');
    for (let prefix = Number(from); prefix <= Number(to); prefix++) regions.set(String(prefix), { place, band: Number(band) });
  }
  const regionFor = pin => {
    for (let length = 5; length >= 2; length--) {
      const region = regions.get(pin.slice(0, length));
      if (region) return region;
    }
    return null;
  };

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-tl-pin]');
    if (!form) return;
    event.preventDefault();
    const pin = form.elements.pincode.value.trim();
    const result = form.querySelector('[data-tl-pin-result]');
    const link = form.querySelector('[data-tl-pin-link]');
    link.hidden = true;
    if (!/^[1-9][0-9]{5}$/.test(pin)) { result.textContent = form.dataset.invalid; return; }
    const region = regionFor(pin);
    const confirmOnly = form.dataset.confirmPins.split(/[\s,]+/).includes(pin);
    if (!region || confirmOnly) {
      result.textContent = form.dataset.pending;
    } else {
      // Making time plus Safexpress transit for the region, multiplied by the safety factor
      const transit = Number(form.dataset.transit.split(',')[region.band]) * Number(form.dataset.factor);
      const arrival = new Date();
      arrival.setDate(arrival.getDate() + Number(form.dataset.making) + transit);
      const date = arrival.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
      result.textContent = `${form.dataset.estimate.replace('__PLACE__', region.place).replace('__DATE__', date)} ${form.dataset.estimateDetail.replace('__TRANSIT__', transit)}`;
    }
    const url = new URL(link.dataset.waBase);
    const message = url.searchParams.get('text').replace(/\n[^\n]*$/, '');
    url.searchParams.set('text', message + '\n' + form.dataset.waPin.replace('__PIN__', pin));
    link.href = url.href;
    link.hidden = false;
  });
  const contextual = () => document.querySelector('[data-wa-product-link]') || document.querySelector('.tt-floating-whatsapp');
  const updateLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    const url = new URL(link.href);
    if (url.hostname !== 'wa.me' || url.pathname !== '/917852089369') return;
    if (!link.hasAttribute('data-wa-contextual') && url.searchParams.has('text')) return;
    const source = contextual();
    if (source && source !== link) link.href = source.href;
  };
  document.querySelectorAll('a[href*="wa.me/917852089369"]').forEach(updateLink);
  for (const type of ['pointerover', 'focusin', 'click']) {
    document.addEventListener(type, event => {
      if (event.target instanceof Element) updateLink(event.target.closest('a[href]'));
    });
  }
})();
